
import { forEach } from "lodash";

export const filterPayload = (filter:any) => {
    let filters: { filterType: string; filterValues: any; }[] = [];

    forEach(Object.keys(filter), (filterData)=>{
      if(filter[filterData].length>0){
          filters.push({
              filterType:filterData,
              filterValues:filter[filterData]
            })
      }
    })
    return filters;
}